/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps, IconSize} from '../../types/types';
import useIconDLS from './../useIconDLS';

/*
 * Defines the Design Language System (DLS) Asset Cargo Icon component.
 */
export const AssetCargoIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.7783 6C16.9201 5.99846 17.0608 6.02535 17.1924 6.07812C17.3238 6.13088 17.4436 6.20866 17.5449 6.30762C17.6462 6.40669 17.7275 6.525 17.7832 6.65527C17.839 6.78573 17.8685 6.9265 17.8701 7.06836V8.79102H17.8613V15.0645C17.8573 15.3255 17.7587 15.5764 17.584 15.7705C17.4113 15.9623 17.1756 16.085 16.9199 16.1182V16.1318C16.8761 16.1398 16.8316 16.1454 16.7871 16.1475H12.1582L12.1279 16.0693C12.0071 15.7257 11.7826 15.4274 11.4854 15.2168C11.1881 15.0063 10.8329 14.8936 10.4688 14.8936C10.1046 14.8936 9.74935 15.0063 9.45215 15.2168C9.15488 15.4274 8.9304 15.7257 8.80957 16.0693L8.78223 16.1475H7.08301C6.79581 16.1474 6.52047 16.0332 6.31738 15.8301C6.11431 15.627 6.00008 15.3516 6 15.0645V7.08008C6.00003 6.93804 6.02759 6.79721 6.08203 6.66602C6.1365 6.53479 6.21678 6.41576 6.31738 6.31543C6.41801 6.21508 6.53754 6.13516 6.66895 6.08105C6.80024 6.02702 6.94103 5.99963 7.08301 6H16.7783Z" fill={iconColor}/>
        <path d="M10.4834 18.0001C11.2083 18.0001 11.796 17.4124 11.796 16.6875C11.796 15.9626 11.2083 15.375 10.4834 15.375C9.75854 15.375 9.1709 15.9626 9.1709 16.6875C9.1709 17.4124 9.75854 18.0001 10.4834 18.0001Z" fill={iconColor}/>
      </svg>
    </svg>
  );
};

export default AssetCargoIcon;
